import React, { useState } from 'react';
import { PackagePlus } from 'lucide-react';
import Modal from './Modal';
import SelectorStockPrueba from './SelectorStockPrueba';

// Carga el catálogo de prueba de Punto V en el almacén (db_productos) de un
// cliente ya creado, con o sin stock. Punto V lo rechaza si el almacén ya
// tiene productos.
const DialogoAlmacenPrueba = ({ cliente, onConfirmar, onCancel }) => {
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const [conStock, setConStock] = useState(true);

  const confirmar = async () => {
    setError('');
    setCargando(true);
    try {
      await onConfirmar({ conStock });
    } catch (err) {
      setError(err.message || 'No se pudo cargar el almacén de prueba');
      setCargando(false);
    }
  };

  return (
    <Modal
      titulo="Cargar almacén de prueba"
      subtitulo={cliente.base_datos}
      icono={PackagePlus}
      onClose={onCancel}
      bloqueado={cargando}
      ancho="md"
      pie={(
        <>
          <button type="button" onClick={onCancel} disabled={cargando} className="px-4 py-2 text-sm text-gray-700 rounded-lg hover:bg-gray-100">
            Cancelar
          </button>
          <button
            type="button"
            onClick={confirmar}
            disabled={cargando}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium disabled:opacity-50 flex items-center gap-2"
          >
            <PackagePlus size={15} />
            {cargando ? 'Cargando…' : 'Cargar almacén'}
          </button>
        </>
      )}
    >
      <div className="rounded-xl border border-blue-200 bg-blue-50 p-3 text-sm text-blue-800 space-y-1.5">
        <p>Llena el almacén de {cliente.slug} con el catálogo de prueba de Punto V: productos, costos, precios e imágenes.</p>
        <p className="text-xs text-blue-700">
          Solo funciona si el almacén está vacío. Si el cliente ya tiene productos, Punto V no carga nada.
        </p>
      </div>
      <div className="mt-4">
        <SelectorStockPrueba id="almacen-prueba-stock" conStock={conStock} onChange={setConStock} disabled={cargando} />
      </div>
      {error && (
        <div className="mt-4 bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-sm">{error}</div>
      )}
    </Modal>
  );
};

export default DialogoAlmacenPrueba;
